module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    class: _vm.btnClassComputed,
    on: {
      "click": _vm.open
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box clean-this"
  }, [_c('div', {
    staticClass: "modal-box--content"
  }, [(_vm.title) ? _c('h3', {
    staticClass: "modal-box--title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('p', {}, [_vm._v("\n          " + _vm._s(_vm.content) + "\n        ")])]), _vm._v(" "), (_vm.footer) ? _c('div', {
    staticClass: "modal-box--footer"
  }, [_vm._v("\n        " + _vm._s(_vm.footer) + "\n      ")]) : (_vm.actions) ? _c('div', {
    staticClass: "modal-box--footer"
  }, _vm._l((_vm.actions), function(action) {
    return _c('button', {
      key: action.name,
      class: action.class,
      attrs: {
        "data-action": action.action
      },
      on: {
        "click": function($event) {
          return _vm.actionTrigger(action.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.global.' + action.name)) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c11bc76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Layout/Modal.vue
// module id = 1852
// module chunks = 0